import Form from "../modules/form";

const Career = {
  init() {
    new Form("#contact-form");
  },
};

export default Career;
